/*
 * Copyright (c) 2019
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import {Injectable} from '@angular/core';
import {SearchableProvider} from '../model/interface/searchable.provider';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {RestResponse, HistoryType} from '../model';
import {environment} from '../../environments/environment';
import {ApiHeaders} from './headers';
import { SystemType } from '../model/enums/system.type';
import { ModuleType } from '../model/enums/module.type';

@Injectable()
export class ReportHistoryProvider implements SearchableProvider {

  constructor(
    private http: HttpClient
  ) {
  }

  getHistorySummary(id: string, page: number, type?: HistoryType, moduleType?: ModuleType): Observable<RestResponse> {
    return this.http
      .get<RestResponse>(`${environment.API_URL}/api/pma/report/${id}/history/summary?page=${page}` +
        (type ? '&type=' + type : '') +
      (moduleType ? '&module=' + moduleType : ''), ApiHeaders.getOptions());
  }

  getHistory(id: string, page: number, query?: string, date?: string, type?: HistoryType, moduleType?: ModuleType ): Observable<RestResponse> {
    return this.http
      .get<RestResponse>(`${environment.API_URL}/api/pma/report/${id}/history?page=${page}` +
      (query ? '&query=' + encodeURIComponent(query) : '') + (date ? '&date=' + date : '') + (type ? '&type=' + type : '') +
      (moduleType ? '&module=' + moduleType : ''), ApiHeaders.getOptions());
  }

  getStageHistory(id: string, type: SystemType): Observable<RestResponse> {
    return this.http
      .get<RestResponse>(`${environment.API_URL}/api/pma/report/${id}/history/stage?type=${type}`, ApiHeaders.getOptions());
  }

  getHistoryEmails(id: string, page: number,): Observable<RestResponse> {
    return this.http
      .get<RestResponse>(`${environment.API_URL}/api/pma/report/${id}/history/emails?page=${page}`, ApiHeaders.getOptions());
  }

  getSearchType(): string {
    return 'REPORT_HISTORY';
  }

  save(id: string, field: string, value: any): Observable<RestResponse> {
    return undefined;
  }

  search(query?: string, id?: string, nonBank?: boolean, lsp?: boolean, page?: number): Observable<RestResponse> {
    return this.getHistory(id, page ? page : 1, query);
  }

  getHistoryDetails(id: string, historyId: string, page: number): Observable<RestResponse> {
    return this.http
      .get<RestResponse>(`${environment.API_URL}/api/pma/report/${id}/history/${historyId}/ask/difference?page=${page}`);
  }
}
